import React from 'react';
import ButtonLink from '../../Form/ButtonLink';
import { TbPencil } from 'react-icons/tb';

interface BoxContentConfirmTableProps {
  show: boolean;
  onClickConfirm: CallableFunction;
  tableName: string;
}

const BoxContentConfirmTable = ({
  show,
  onClickConfirm,
  tableName,
}: BoxContentConfirmTableProps) => {
    if (!show) return null;
    return (
    <div className='grid gap-3 rounded-t-lg p-4 pb-2 shadow-reverse-md'>
        <div className='text-center font-bold text-lg leading-none'>Confirme se você está mesa abaixo</div>
        <div className='flex items-center justify-center gap-1 text-center'>
            <hr className='w-full border-sky-100' />
            <ButtonLink className='text-nowrap text-2xl gap-0.5 zoomInIcon' onClick={() => onClickConfirm()}>
                <span><TbPencil /></span>
                <span className='font-black'>{ tableName }</span>
            </ButtonLink>
            <hr className='w-full border-sky-100' />
        </div>
        <div className='grid w-full text-center gap-1'>
            <span className='text-gray-500 text-sm font-medium leading-none'>Caso tenha mudado clique no botão acima</span>
            <span className='text-gray-400 text-xs leading-none'>Esta informação está no display da mesa</span>
        </div>
    </div>
  )
}

export default BoxContentConfirmTable;